var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnwindExp = function SvgUnwindExp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none",
    stroke: "#727582",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M8 4.334v-.667c0-.737.597-1.333 1.333-1.333H10a1 1 0 0 0 1-1M5.666 7v1.334m0 0v1.333m0-1.333H4.333m1.333 0H7M11.5 9.5h.006M9.833 7.167h.007M5.075 4.334h5.85a3.333 3.333 0 0 1 3.322 3.065l.412 5.107a2 2 0 0 1-1.994 2.16h-.096a2 2 0 0 1-1.789-1.105l-.596-1.192A.67.67 0 0 0 9.588 12H6.412a.67.67 0 0 0-.597.369L5.22 13.56a2 2 0 0 1-1.789 1.106h-.096a2 2 0 0 1-1.993-2.16l.411-5.108a3.333 3.333 0 0 1 3.323-3.065M11.5 9.667a.167.167 0 1 1 0-.333.167.167 0 0 1 0 .333M9.833 7a.167.167 0 1 1 0 .333.167.167 0 0 1 0-.333"
  })));
};
export default SvgUnwindExp;